import AppUsersClient from "../clients/AppUsersClient";
import moment from 'moment';

const resource = '/overallocations';

export default {
  getForPeriod(startDate, endDate, forGroup) {
    return new Promise(function(resolve, reject) {      
      AppUsersClient.get(`${resource}/?fromdate=${moment(startDate).format('YYYY-MM-DD')}&todate=${moment(endDate).format('YYYY-MM-DD')}&forGroup=${(forGroup ? forGroup : '')}`)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
      });
  },
};
